import * as flashActions from 'pkg/actions/flashes';

import * as endpoints from 'pkg/api/endpoints/auto';
import * as sdk from 'pkg/core/sdk';
import { crash } from 'pkg/errors/errors';

export const exportPayoutRows = async (
	organizationId: number,
	id: string,
	queryParams?: URLSearchParams
): Promise<[boolean, string]> => {
	const params = new URLSearchParams();
	params.set('payout_id', id.toString());

	if (queryParams) {
		queryParams.forEach((value, key) => {
			if (key !== 'page' && key !== 'count' && key !== 'payout_id') {
				params.set(key, value);
			}
		});
	}

	const url = `${endpoints.PayoutRows.Export(organizationId)}?${params.toString()}`;
	const req = await sdk.post(url, {});

	if (req.status === 501) {
		flashActions.show({
			title: 'This export is coming soon!',
		});
		return [false, null];
	}

	if (req.ok) {
		const text = await req.text();
		return [true, text];
	}

	flashActions.show({
		title: crash().title,
	});

	return [false, null];
};

export const exportPayoutsList = async (
	organizationId: number,
	queryParams?: URLSearchParams
): Promise<[boolean, string]> => {
	const params = new URLSearchParams();
	if (queryParams) {
		queryParams.forEach((value, key) => {
			params.set(key, value);
		});
	}

	const url = `${endpoints.PayoutsReports.Export(organizationId)}?${params.toString()}`;
	const req = await sdk.post(url, {});

	if (req.status === 501) {
		flashActions.show({
			title: 'This export is coming soon!',
		});
		return [false, null];
	}

	if (req.ok) {
		const text = await req.text();
		return [true, text];
	}

	flashActions.show({
		title: crash().title,
	});

	return [false, null];
};
